import React, { useState, useEffect } from 'react';
import api from '../../servicios/api';

const FilaMetrica = ({ etiqueta, detalle, porcentaje, ultima }) => (
  <div style={{
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '10px 14px',
    borderBottom: ultima ? 'none' : '1px solid #e5e7eb'
  }}>
    <div>
      <div style={{ fontSize: '12px', color: '#374151', fontWeight: '600' }}>{etiqueta}</div>
      {detalle && <div style={{ fontSize: '11px', color: '#9ca3af', marginTop: '1px' }}>{detalle}</div>}
    </div>
    <span style={{ fontSize: '16px', fontWeight: '700', color: colorPorcentaje(porcentaje) }}>
      {porcentaje}%
    </span>
  </div>
);

const colorPorcentaje = (pct) => {
  if (pct >= 80) return '#10b981';
  if (pct >= 50) return '#f59e0b';
  return '#ef4444';
};

const DashboardGlobal = ({ onAbrirProyecto, onEliminarProyecto, totalProyectos, usuarioActual }) => {
  const [datos, setDatos] = useState(null);
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState('');
  const [confirmandoId, setConfirmandoId] = useState(null);
  const [eliminandoId, setEliminandoId] = useState(null);
  const [errorEliminar, setErrorEliminar] = useState('');
  const esSuperAdmin = usuarioActual?.rol === 'superadmin';

  useEffect(() => {
    const cargar = async () => {
      setCargando(true);
      setError('');
      try {
        // Para el dashboard global, no enviamos X-Proyecto-Id
        // Lo hacemos eliminando temporalmente el header en esta llamada
        const token = localStorage.getItem('token');
        const response = await api.get('/dashboard/global', {
          headers: { Authorization: `Bearer ${token}` },
          // Sobreescribir el X-Proyecto-Id para este endpoint específico
          transformRequest: [(data, headers) => {
            delete headers['X-Proyecto-Id'];
            return data;
          }]
        });
        setDatos(response.data);
      } catch (err) {
        setError(err.response?.data?.error || 'Error al cargar el dashboard global');
      } finally {
        setCargando(false);
      }
    };
    cargar();
  }, []);

  const handleEliminar = async (proyectoId) => {
    setEliminandoId(proyectoId);
    setErrorEliminar('');
    try {
      await onEliminarProyecto(proyectoId);
      setDatos(prev => ({
        ...prev,
        proyectos: prev.proyectos.filter(p => (p.proyecto.id || p.proyecto._id).toString() !== proyectoId.toString()),
        totales: { ...prev.totales, proyectos: prev.totales.proyectos - 1 }
      }));
      setConfirmandoId(null);
    } catch (err) {
      setErrorEliminar(err.error || err.mensaje || 'Error al eliminar el proyecto');
      setConfirmandoId(null);
    } finally {
      setEliminandoId(null);
    }
  };

  if (cargando) {
    return (
      <div style={{ padding: '40px', textAlign: 'center', color: '#6b7280' }}>
        <p style={{ fontSize: '16px' }}>Cargando vista global...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ padding: '40px', textAlign: 'center' }}>
        <div style={{ background: '#fef2f2', border: '1px solid #fca5a5', borderRadius: '8px', padding: '20px', color: '#dc2626' }}>
          {error}
        </div>
      </div>
    );
  }

  if (!datos || !datos.proyectos || datos.proyectos.length === 0) {
    return (
      <div style={{ padding: '40px', textAlign: 'center', color: '#6b7280' }}>
        <p>No tienes proyectos para mostrar.</p>
      </div>
    );
  }

  const { proyectos, totales } = datos;

  return (
    <div style={{ padding: '24px' }}>
      <h1 style={{ fontSize: '24px', fontWeight: '700', color: '#111827', marginBottom: '28px' }}>
        Vista Global
      </h1>

      {/* Error al eliminar */}
      {errorEliminar && (
        <div style={{ marginBottom: '16px', padding: '10px 16px', background: '#fef2f2', border: '1px solid #fecaca', borderRadius: '8px', color: '#dc2626', fontSize: '13px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span>{errorEliminar}</span>
          <button onClick={() => setErrorEliminar('')} style={{ background: 'none', border: 'none', color: '#dc2626', cursor: 'pointer', fontSize: '16px', lineHeight: 1 }}>✕</button>
        </div>
      )}

      {/* Tarjetas de totales */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: '16px', marginBottom: '32px' }}>
        <TarjetaTotal titulo="Proyectos" valor={totales.proyectos} color="#111827" />
      </div>

      {/* Cards de proyectos */}
      <h2 style={{ fontSize: '16px', fontWeight: '700', color: '#374151', marginBottom: '16px' }}>
        Proyectos
      </h2>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: '16px', marginBottom: '36px' }}>
        {proyectos.map((item) => {
          const pid = item.proyecto.id || item.proyecto._id;
          return (
            <div
              key={pid}
              style={{
                background: '#ffffff',
                border: '1px solid #e5e7eb',
                borderRadius: '12px',
                padding: '20px',
                boxShadow: '0 1px 4px rgba(0,0,0,0.05)',
                display: 'flex',
                flexDirection: 'column',
                gap: '14px'
              }}
            >
              <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                <div style={{
                  width: '40px', height: '40px', borderRadius: '8px',
                  background: 'linear-gradient(135deg, #111827 0%, #374151 100%)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  color: '#fff', fontWeight: '700', fontSize: '18px', flexShrink: 0
                }}>
                  {item.proyecto.nombre.charAt(0).toUpperCase()}
                </div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <h3 style={{ margin: 0, fontSize: '15px', fontWeight: '700', color: '#111827', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    {item.proyecto.nombre}
                  </h3>
                  {item.proyecto.manager && (
                    <p style={{ margin: '2px 0 0', fontSize: '12px', color: '#6b7280' }}>
                      {item.proyecto.manager}
                    </p>
                  )}
                </div>
                <span style={{
                  fontSize: '11px', fontWeight: '600', padding: '2px 8px', borderRadius: '12px',
                  background: item.proyecto.estado === 'activo' ? '#dcfce7' : '#f3f4f6',
                  color: item.proyecto.estado === 'activo' ? '#16a34a' : '#6b7280'
                }}>
                  {item.proyecto.estado}
                </span>
              </div>

              {(() => {
                const filas = [
                  {
                    key: 'subcontratos',
                    etiqueta: 'Subcontratos',
                    detalle: `${item.subcontratos.completadas}/${item.subcontratos.total}`,
                    porcentaje: item.subcontratos.porcentaje
                  },
                  {
                    key: 'materiales',
                    etiqueta: 'Materiales',
                    detalle: `${item.materiales.completados}/${item.materiales.total}`,
                    porcentaje: item.materiales.porcentaje
                  }
                ];
                if (item.programa) {
                  filas.push({ key: 'programa', etiqueta: 'Programa de Obra', porcentaje: item.programa.pct });
                }
                if (item.calidad) {
                  filas.push({
                    key: 'calidad',
                    etiqueta: 'Calidad',
                    detalle: `${item.calidad.entregadas}/${item.calidad.total}`,
                    porcentaje: item.calidad.porcentaje
                  });
                }
                if (item.recepcionMunicipal) {
                  filas.push({
                    key: 'recepcion',
                    etiqueta: 'Recepción Municipal',
                    detalle: `${item.recepcionMunicipal.completados}/${item.recepcionMunicipal.total}`,
                    porcentaje: item.recepcionMunicipal.porcentaje
                  });
                }
                return (
                  <div style={{
                    background: '#ffffff',
                    borderRadius: '10px',
                    boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
                    border: '1px solid #f3f4f6'
                  }}>
                    {filas.map((f, i) => (
                      <FilaMetrica
                        key={f.key}
                        etiqueta={f.etiqueta}
                        detalle={f.detalle}
                        porcentaje={f.porcentaje}
                        ultima={i === filas.length - 1}
                      />
                    ))}
                  </div>
                );
              })()}

              {/* Avance + acciones */}
              <div style={{ paddingTop: '8px', borderTop: '1px solid #f3f4f6' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: confirmandoId === pid ? '10px' : 0 }}>
                  <div>
                    <span style={{ fontSize: '11px', color: '#6b7280' }}>Avance global</span>
                    <span style={{ fontSize: '20px', fontWeight: '700', color: colorPorcentaje(item.avanceGlobal), marginLeft: '8px' }}>
                      {item.avanceGlobal}%
                    </span>
                  </div>
                  <div style={{ display: 'flex', gap: '6px' }}>
                    <button
                      onClick={() => onAbrirProyecto && onAbrirProyecto(item.proyecto)}
                      style={{ padding: '6px 14px', background: '#111827', color: '#fff', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '13px', fontWeight: '600' }}
                    >
                      Abrir ▶
                    </button>
                    {esSuperAdmin && (totalProyectos > 1) && (
                      <button
                        onClick={() => setConfirmandoId(confirmandoId === pid ? null : pid)}
                        disabled={eliminandoId === pid}
                        style={{ padding: '6px 10px', background: '#fef2f2', color: '#dc2626', border: '1px solid #fecaca', borderRadius: '6px', cursor: 'pointer', fontSize: '13px', fontWeight: '600' }}
                      >
                        🗑
                      </button>
                    )}
                  </div>
                </div>

                {/* Confirmación inline */}
                {esSuperAdmin && confirmandoId === pid && (
                  <div style={{ background: '#fef2f2', border: '1px solid #fecaca', borderRadius: '8px', padding: '10px 12px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '8px' }}>
                    <span style={{ fontSize: '12px', color: '#991b1b', fontWeight: 600 }}>
                      ¿Eliminar "{item.proyecto.nombre}"? Se borrarán todos sus datos.
                    </span>
                    <div style={{ display: 'flex', gap: '6px', flexShrink: 0 }}>
                      <button
                        onClick={() => setConfirmandoId(null)}
                        style={{ padding: '4px 12px', background: '#fff', border: '1px solid #d1d5db', borderRadius: '6px', cursor: 'pointer', fontSize: '12px', color: '#374151' }}
                      >
                        Cancelar
                      </button>
                      <button
                        onClick={() => handleEliminar(pid)}
                        disabled={eliminandoId === pid}
                        style={{ padding: '4px 12px', background: '#dc2626', border: 'none', borderRadius: '6px', cursor: eliminandoId === pid ? 'not-allowed' : 'pointer', fontSize: '12px', color: '#fff', fontWeight: 700, opacity: eliminandoId === pid ? 0.6 : 1 }}
                      >
                        {eliminandoId === pid ? 'Eliminando...' : 'Sí, eliminar'}
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>

    </div>
  );
};

const TarjetaTotal = ({ titulo, valor, color, subtitulo }) => (
  <div style={{
    background: '#ffffff', border: '1px solid #e5e7eb', borderRadius: '12px',
    padding: '20px', boxShadow: '0 1px 4px rgba(0,0,0,0.05)'
  }}>
    <p style={{ margin: '0 0 4px', fontSize: '12px', color: '#6b7280', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
      {titulo}
    </p>
    <p style={{ margin: 0, fontSize: '28px', fontWeight: '800', color }}>
      {valor}
    </p>
    {subtitulo && (
      <p style={{ margin: '4px 0 0', fontSize: '11px', color: '#9ca3af' }}>{subtitulo}</p>
    )}
  </div>
);

export default DashboardGlobal;
